import React from 'react';
import has from 'lodash/has';
import RegistrationCard from '../../RegistrationCard';
import MinorAddressForm from './MinorAddressForm';

const MinorAddress = ({ currentRegistration, onSubmit, match }) => {
  // Firebase has trouble with deeply nested objects that are arrays so you
  // have to modify the push data to use a nested update syntax.
  //
  // Additionally we need to pass the complete nested object or else it
  // gets overwritten, so for minors we pass in the contact information along
  // with the address initial values.

  const { index } = match.params;
  const initialValues = {
    nextStep: `minors/${index}/questionnaire/0`
  };

  if (currentRegistration.minors && currentRegistration.minors[index]) {
    const {
      firstName,
      lastName,
      phone,
      dateOfBirth,
      address,
      city,
      province,
      postal,
      country
    } = currentRegistration.minors[index];
    let { address2 } = currentRegistration.minors[index];
    address2 = address2 || null;

    initialValues[`minors/${index}`] = {
      firstName,
      lastName,
      phone,
      dateOfBirth,
      address,
      address2,
      city,
      province,
      postal,
      country
    };
  }

  //use default value from current registration.
  ['address', 'address2', 'city', 'province', 'postal', 'country'].forEach(key => {
    if (
      (
        !has(initialValues, ['minors', index, key])
          ||
        !initialValues[`minors/${index}`][key]
      )
      &&
      currentRegistration[key]
    ) {
      initialValues[`minors/${index}`][key] = currentRegistration[key];
    }
  })

  return (
    <RegistrationCard
      title="Enter the minor's address"
      subtitle="This has been pre-populated based on your answers."
    >
      <MinorAddressForm
        onSubmit={onSubmit}
        initialValues={initialValues}
        index={index}
      />
    </RegistrationCard>
  );
};

MinorAddress.propTypes = {};
MinorAddress.defaultProps = {};

export default MinorAddress;



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorAddress/MinorAddress.jsx